/*
  IconDirectionContextValue is being imported as a leaf node import in order to prevent extra icons froms being
  downloaded when trying to use the FluentProvider.
  This issue has more context: https://github.com/microsoft/fluentui/issues/30909
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
